module.exports = __webpack_public_path__ + "static/img/cabinet12_4.2a82effe.gif";